export class Position {
    x = 0;
    y = 0;

    constructor(posX?: number | string, posY?: number | string) {
        this.x = posX ? parseFloat(posX.toString()) : 0;
        this.y = posY ? parseFloat(posY.toString()) : 0;
    }
}
